import { useAuth } from "@/hooks/useAuth";
import { appActions } from "@/redux/actions/app.actions";
import { useDispatch } from "@/redux/store";
import { getAuth } from "firebase/auth";
import type { ReactNode } from "react";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

interface AuthWrapperProps {
  children: ReactNode;
}

export const AuthWrapper = ({ children }: AuthWrapperProps) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { isAuthenticated, onAuthStateChange } = useAuth();

  useEffect(() => {
    if (isAuthenticated) return;

    const fullUrl = `${location.pathname}${location.search}${location.hash}`;

    dispatch(appActions.setAppState({ redirectTo: fullUrl }));
    navigate("/");
  }, [navigate, isAuthenticated, dispatch, location]);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = auth.onAuthStateChanged(onAuthStateChange);
    return () => unsubscribe();
  }, [onAuthStateChange]);

  if (!isAuthenticated) return null;
  return <>{children}</>;
};
